var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 48 39.375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.4224 10.5011V21.1564C27.3241 20.0874 29.0867 19.6875 31.0287 19.6875V8.4375C28.7927 8.4375 26.9616 9.1545 25.4224 10.5011ZM16.9849 8.4375V19.6875C18.9203 19.6875 20.7209 20.0541 22.5912 21.0993V10.4549C21.0902 9.15028 19.2562 8.4375 16.985 8.4375H16.9849Z",
    fill: "var(--fill-0, #071EB7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.0913 4.21875C45.0913 1.88888 43.2213 0 40.8912 0H7.14117C4.81129 0 2.92242 1.88888 2.92242 4.21875V30.9375H45.0912L45.0913 4.21875ZM33.8599 21.0938C33.8599 21.8712 33.2311 22.5 32.4537 22.5H31.2294C28.9571 22.5 26.5679 23.138 25.0653 24.8423C24.5933 25.3773 23.7411 25.4887 23.1358 25.0027C21.4442 23.644 19.5945 22.5 17.4251 22.5C15.8346 22.5 14.1538 22.7457 14.1538 21.0938V7.03125C14.1538 5.41481 15.7091 5.625 17.2269 5.625C19.6941 5.625 22.0862 6.51853 24.0165 8.03653C25.9465 6.51844 28.3388 5.625 30.8057 5.625C32.3236 5.625 33.8599 5.41481 33.8599 7.03125V21.0938ZM1.4136 33.75C0.317573 33.75 -0.356677 34.9491 0.198604 35.8942C1.42045 37.9749 3.68226 39.375 6.2647 39.375H41.7352C44.3177 39.375 46.5791 37.9749 47.8015 35.8942C48.3567 34.949 47.6824 33.75 46.5864 33.75H1.4136Z",
    fill: "var(--fill-0, #071EB7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill5);
export default __webpack_public_path__ + "static/media/skill-5.e68a04846f1abc613f25baf40f13fafd.svg";
export { ForwardRef as ReactComponent };